import React, {useEffect, useState} from 'react';
import axios from "axios";
import config from "../../../../Helpers/config.json";
import {errorMessages} from "../../../../Helpers/ErrorMessages";
import {useEditLedgers} from "./useEditLedgers";



export const useEntityLedgers = (actions,component='') => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState('idle');
    const [openDelete, setOpenDelete] = useState(false)
    const [entity_id, setEntityId] = useState('')
    const {isResolvedEdit, editProps} = useEditLedgers(component)



    useEffect(() => {
        setLoading('pending')
        axios.get(`${config.epharmUrl}/accounting/entity_behaviour`,{params:{entity_type:component}}).then(res => {
            const response = res.data;
            const dt = response ? response : {};
            const arr = dt.data ? dt.data : []
            setData(arr)
            setLoading('success')
        }).catch(err => {
            errorMessages(err, null, actions)
            setLoading('error')
        })
    }, [isResolvedEdit, component])

    const handleOpenDelete = (id) =>{
        setOpenDelete(true)
        setEntityId(id)
    }

    const handleCloseDelete = () =>{
        setOpenDelete(false)
    }

    const handleDelete = () => {
        const formData = new FormData();
        formData.append('id', entity_id);
        axios.post(`${config.epharmUrl}/accounting/entity_behaviour/delete`, formData).then(() => {
            const arr = data.filter(item=>item.id !== entity_id)
            actions.snackbarActions.successSnackbar(`Ledger deleted successfully`);
            setOpenDelete(false)
            setData(arr)
        }).catch(err => {
            errorMessages(err, null, actions)
        })
    }

    const closeSnackbar = () =>{
        actions.snackbarActions.hideSnackBar()
    }



    const isLoading = loading === 'pending'
    const isSuccess = loading === 'success'
    const isError = loading === 'error'

    return {data, isLoading, isSuccess, isError, openDelete,handleCloseDelete,
    handleOpenDelete,entity_id, handleDelete, editProps, closeSnackbar}
}